import React, { createContext, Dispatch, useState } from 'react';

export interface ColumnViewTreeType {
  root: BaseNode[] | [];
  setRoot: Dispatch<BaseNode[]>;
  selections: Selections;
  setSelections: Dispatch<Selections>;
  activeNode: BaseNode | undefined;
  setActiveNode: Dispatch<BaseNode | undefined>;
}

export const ColumnViewContext = createContext<ColumnViewTreeType>({
  root: [],
  setRoot: () => null,
  selections: new Set(),
  setSelections: () => null,
  activeNode: undefined,
  setActiveNode: () => undefined,
});

export function ColumnViewContextProvider({ children }: { children: React.ReactNode }) {
  const [root, setRoot] = useState<NodeSet>([]);
  const [selections, setSelections] = useState<Selections>(new Set());
  const [activeNode, setActiveNode] = useState<BaseNode | undefined>();

  return (
    <ColumnViewContext.Provider value={{ root, setRoot, selections,  setSelections, activeNode, setActiveNode }}>
        {children}
    </ColumnViewContext.Provider>
  );
}